export function parseMoveStringToIndices(
  move: string
): [number, number, number, number] {
  const elements: string[] = move.match(/[^\d]+|\d+/g) ?? [];
  const startColumn = parseInt(elements[0], 36) - 10;
  const startRow = 11 - parseInt(elements[1]);
  const endColumn = parseInt(elements[2], 36) - 10;
  const endRow = 11 - parseInt(elements[3]);
  return [startRow, startColumn, endRow, endColumn];
}

const toLetter: string[] = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
];

export function parseMoveIndicesToString(
  startRow: number,
  startColumn: number,
  endRow: number,
  endColumn: number
): string {
  return `${toLetter[startColumn]}${11 - startRow}${toLetter[endColumn]}${
    11 - endRow
  }`;
}
